import { render } from "./ApprovalRefusalForm.vue?vue&type=template&id=889af1a8"
import script from "./ApprovalRefusalForm.vue?vue&type=script&lang=js"
export * from "./ApprovalRefusalForm.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ApprovalRefusalForm.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_e58f5c89%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fclaim%2Fdetails%2Faction%2FApprovalRefusalForm.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__